module.exports = __webpack_public_path__ + "img/personaje-0.b66e65e0.png";